import React, { useEffect, useRef, useState } from "react";
import "./Message.css";
import { Avatar, Badge, Button, Col, Row, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setChatSpace } from "../../../Redux/ChatSpaceSlice";
import {
  faBell,
  faBellSlash,
  faCircleUser,
  faFaceSmile,
  faFileAudio,
  faImage,
  faPhone,
  faUser,
  faUserSlash,
  faVideo,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EmojiPicker from "emoji-picker-react";
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router-dom";
import TooltipOptions from "../../TooltipOptions/TooltipOptions";
import axios from "axios";
import { initializeSocket } from "../../../Services/socket";

function Message() {
  const dispatch = useDispatch();
  const [openConversationSetting, setOpenConversationSetting] = useState(false);
  const [messages, setMessages] = useState([]);
  const [messageInput, setmessageInput] = useState({
    message: "",
    openEmoji: false,
  });
  const messageBodyRef = useRef(null);
  const conversationInfo = useSelector((state) => state.chatSpace.info);
  const id = conversationInfo?.conversationId;
  const user = localStorage.getItem("userInfo");
  const userId = JSON.parse(user).id;
  const [socket, setSocket] = useState(null);
  const [partner, setPartner] = useState({});

  useEffect(() => {
    if (userId && id) {
      const newSocket = initializeSocket(userId);
      console.log("Socket initialized:", newSocket);
      setSocket(newSocket);
      newSocket.emit("join_room", id, userId);
      console.log("Emit join_room:", { room: id, userId });
    }
    if (messageBodyRef.current) {
      // Scroll to the bottom of the container
      messageBodyRef.current.scrollTop = messageBodyRef.current.scrollHeight;
    }
    const fetchMessages = async () => {
      try {
        console.log("Fetching messages for conversation:", id);
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/conversation/${id}/${userId}`
        );
        console.log("Fetched messages:", response.data);
        setMessages(response.data.data.messages);
        setPartner(response.data.data.partner);
      } catch (error) {
        console.log("Error fetching messages:", error);
      }
    };

    if (id) {
      fetchMessages();
    }
  }, [id]);

  useEffect(() => {
    if (socket) {
      socket.on("thread", (data) => {
        console.log("Received thread message:", data);
        setMessages((prev) => [...prev, data]);
        setmessageInput({
          message: "",
          openEmoji: false,
        });
      });
      return () => {
        socket.off("thread");
      };
    }
  }, [socket]);

  const handleSendMessage = async () => {
    if (messageInput.message.trim() !== "" && socket) {
      const message = {
        conversationId: id,
        author: userId,
        content: messageInput.message,
      };
      try {
        await axios
          .post(
            `${process.env.REACT_APP_SERVER_URL}/conversation/send-message`,
            message
          )
          .then((response) => {
            console.log("Message sent, server response:", response.data);
            const newMessage = {
              text: messageInput.message,
              sender: userId,
              room: id,
              id: response.data.message._id,
            };
            socket.emit("send", newMessage);
            console.log("Emit send:", newMessage);
          });
      } catch (error) {
        console.log("Error sending message:", error);
      }
    }
  };
  return (
    <>
      <Row className="messageHeader" align={"middle"}>
        <Col span={16} className="messageHeaderTitleWrapper">
          <Tooltip
            placement="leftTop"
            color="whiteSmoke"
            overlayStyle={{ width: "500px" }}
            open={openConversationSetting}
            title={
              <ConversationSetting
                setOpen={setOpenConversationSetting}
                dispatch={dispatch}
              />
            }
          >
            <button
              className="messageHeaderTitleBtn"
              onClick={() => setOpenConversationSetting((prev) => !prev)}
            >
              <Badge
                dot={false}
                style={{
                  width: "8px",
                  height: "8px",
                  top: "4px",
                  right: "4px",
                }}
              >
                <Avatar.Group>
                  <Avatar
                    shape="circle"
                    style={{
                      borderColor: "lightgray",
                    }}
                    src={partner.avatar}
                    icon={<FontAwesomeIcon icon={faUser} />}
                  />
                </Avatar.Group>
              </Badge>
              <span className="messageHeaderTitle">{partner.username}</span>
            </button>
          </Tooltip>
        </Col>
        <Col span={8} className="messageHeaderFunction">
          <Button shape="circle" variant="filled" size="small">
            <FontAwesomeIcon icon={faPhone} />
          </Button>
          <Button shape="circle" variant="filled" size="small">
            <FontAwesomeIcon icon={faVideo} />
          </Button>
          <Button
            shape="circle"
            variant="filled"
            size="small"
            onClick={() => dispatch(setChatSpace({ open: null, info: null }))}
          >
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </Col>
      </Row>
      <div className="messageBody" ref={messageBodyRef}>
        {messages.map((m) => (
          <TheMessage
            key={m.id}
            own={m.sender === userId} // You'll need to get currentUserId from your auth state
            title={m.text}
            avatar={m.avatar || "https://i.pravatar.cc/300"}
          />
        ))}
        {/* <TheMessage title="hello" avatar={"https://i.pravatar.cc/300"} />
        <TheMessage own title="hi" avatar={"https://i.pravatar.cc/300"} />
        <TheMessage
          title="wanna be friend?"
          avatar={"https://i.pravatar.cc/300"}
        />
        <TheMessage
          title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet eros quis nisl sollicitudin tincidunt. Cras at feugiat nulla. Curabitur id turpis at nisi consequat tincidunt. Integer tincidunt enim in odio consequat, in efficitur libero bibendum. Morbi nec leo eu est aliquam hendrerit. In fermentum neque id nulla volutpat, a hendrerit eros interdum. Duis ultricies odio sed libero fringilla congue. Pellentesque eget feugiat augue. Nulla facilisi. Aliquam erat volutpat."
          avatar={"https://i.pravatar.cc/300"}
        />
        <TheMessage
          own
          title="Vivamus elementum, ex sit amet ultrices vestibulum, est ligula egestas nunc, id efficitur sem nunc id purus. Sed vestibulum sapien id nulla vehicula, a efficitur lectus tincidunt. Ut porttitor quam ligula, et blandit metus scelerisque in. Proin volutpat bibendum eros, sit amet blandit turpis convallis ac. Sed porttitor nisi sed nunc egestas, in posuere nisl euismod. Etiam eget orci ex. Fusce ut turpis non sem ultricies tincidunt. Mauris viverra vehicula lectus id vulputate."
          avatar={"https://i.pravatar.cc/300"}
        /> */}
      </div>

      <Row className="messageFooter">
        {(
          <>
            <Col className="messageFooterBtnWrapper" span={5}>
              <Button shape="circle" variant="filled" size="small">
                <FontAwesomeIcon icon={faImage} />
              </Button>
              <Button shape="circle" variant="filled" size="small">
                <FontAwesomeIcon icon={faFileAudio} />
              </Button>
            </Col>
            <Col span={16}>
              <TextArea
                autoSize={{ minRows: 1, maxRows: 3 }}
                maxLength={1500}
                placeholder="Nhập tin nhắn"
                value={messageInput.message}
                onChange={(e) => {
                  setmessageInput((prev) => ({
                    ...prev,
                    message: e.target.value,
                  }));
                }}
                onKeyDown={(e) => {
                  if (
                    e.key === "Enter" &&
                    !e.shiftKey &&
                    !e.ctrlKey &&
                    !e.altKey &&
                    !e.metaKey
                  ) {
                    e.preventDefault();
                    handleSendMessage();
                  }
                }}
              />
            </Col>
            <Col
              span={3}
              className="messageFooterBtnWrapper emojiPickerWrapper"
            >
              {messageInput.openEmoji && (
                <EmojiPicker
                  className="emojiPicker"
                  onEmojiClick={(emoji) => {
                    setmessageInput((prev) => ({
                      openEmoji: false,
                      message: prev.message + emoji.emoji,
                    }));
                  }}
                  searchDisabled
                  previewConfig={{
                    showPreview: false,
                  }}
                  width={300}
                  height={300}
                />
              )}
              <Button
                shape="circle"
                variant="filled"
                size="small"
                onClick={() =>
                  setmessageInput((prev) => ({
                    ...prev,
                    openEmoji: !prev.openEmoji,
                  }))
                }
              >
                <FontAwesomeIcon icon={faFaceSmile} />
              </Button>
            </Col>
          </>
        ) || (
          <>
            <Col span={24}>
              <h4>Hiện không thể gửi tin nhắn cho đối phương</h4>
            </Col>
          </>
        )}
      </Row>
    </>
  );
}

function ConversationSetting({ setOpen, dispatch }) {
  const navigate = useNavigate();
  return (
    <Row style={{ color: "black" }}>
      <TooltipOptions
        icon={faCircleUser}
        title="Xem trang cá nhân"
        endSecion={true}
        onClick={() => {
          setOpen(false);
          dispatch(setChatSpace({ open: null, info: null }));
          setTimeout(() => {
            navigate(`/profile/${"abc123"}`);
          }, 0);
        }}
      />
      <TooltipOptions icon={faBell} title="Tắt thông báo" endSecion={true} />
      <TooltipOptions
        icon={faBellSlash}
        title="Bật lại thông báo"
        endSecion={true}
      />
      <TooltipOptions icon={faUser} title="Chặn" />
      <TooltipOptions icon={faUserSlash} title="Bỏ chặn" />
    </Row>
  );
}

function TheMessage({ own = false, avatar, title }) {
  return (
    <div className={`messageContent ${own && "own"}`}>
      <div className="messageContentTop">
        {!own && (
          <img
            className="messageAvtImg"
            src={avatar}
            alt="Conversation avatar"
          />
        )}
        <span className="messageContentText">
          {/* <img
            className="messageContentImg"
            src="https://images.pexels.com/photos/1170986/pexels-photo-1170986.jpeg?auto=compress&cs=tinysrgb&w=600"
          /> */}
          {/* <img
            className="messageContentImg"
            src="https://t3.ftcdn.net/jpg/02/36/99/22/360_F_236992283_sNOxCVQeFLd5pdqaKGh8DRGMZy7P4XKm.jpg"
          /> */}
          <span>{title}</span>
        </span>
      </div>
      <div className={`messageContentBottom ${!own && "ownTimeAgo"}`}>
        1 sec ago
      </div>
    </div>
  );
}

export default Message;
